import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { AddNumber } from 'pages/settings/pages/numbers/pages/AddNumber/ui/AddNumber'
import { AddNumberLayout } from 'pages/settings/pages/numbers/pages/AddNumber/layout/AddNumberLayout'
import { AddNumberAccessLayout } from 'pages/settings/pages/numbers/pages/AddNumber/layout/AddNumberAccessLayout'

export const AddNumberRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<AddNumberAccessLayout />}>
        <Route element={<AddNumberLayout />}>
          <Route path={'/'} element={<AddNumber />} />
        </Route>
      </Route>
    </RoutesWithNotFound>
  )
}
